export default __webpack_public_path__ + "static/media/sumhr-logo.e59af425.svg";